export default "<h3>Private negotiation dashboard</h3>";